import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, importProvidersFrom } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../core/services/api.service';
import { HelperService } from '../../../services/helper.service';
import { ObligationService } from '../../../services/obligation.service';
import { LookupService} from '../../../services/lookup.service'
import { Credit } from '../../../core/models/credit.model'
import { AutocompleteComponent } from 'angular-ng-autocomplete';

@Component({
  selector: 'app-credit',
  templateUrl: './credit.component.html',
  styleUrls: ['./credit.component.css'],
  providers: [NgbModal] 
})
export class CreditComponent implements OnInit {

  fgCredits: UntypedFormGroup;
  pct: any = {};
  ibraRegions: any = [];
  ibraSubRegions: any = [];
  filteredSubregions: any = [];
  offsetTradingGroups: any[] = null;
  keyword: any = "combined";
  public creditSearchResults: any = [];
  modalReference: any
  mode: string = "A"; //add by default
  buttonTitle: string = "Create";
  headerTitle: string = "Add obligation";
  obligationId: number = 0;
  public error = "";
  credit: Credit = null;
  ecoOTG: string = "";
  ibraKeyword: any ='';
  autoCompleteSubregions: any = [];
  selectedIbraRegionName = '';
  selectedSubregionId: number = 0;
  selectedRegionId: number = 0;
  isIbraSubregionSelectionInvalid: boolean = false;
  
  @ViewChild("autoComplete2", { static: false }) autoComplete: AutocompleteComponent;
  @Output() added: EventEmitter<any> = new EventEmitter();
  @Output() updated: EventEmitter<any> = new EventEmitter();

  @ViewChild("content", { static: false }) modalContent: TemplateRef<any>;


  pctName: any;
  showCreditSearch: boolean = true;

  constructor(private fb: UntypedFormBuilder, private modalService: NgbModal,
    private apiService: ApiService, private helperService: HelperService,
    private lookupService:LookupService,
    private obligationService: ObligationService) { }

  ngOnInit() {
    this.GenerateFormGroup();
    this.loadIbraRegions();
  }

  GenerateFormGroup() {
    this.fgCredits = this.fb.group({
      ibraRegion: [{ value: '', disabled: !this.allowEdit }, Validators.compose([Validators.required])],
      ibraSubregion: [{ value: '', disabled: !this.allowEdit }, Validators.compose([Validators.required])],
      creditCategory: [{ value: '', disabled: !this.allowEdit }, Validators.compose([Validators.required])],
      creditTypeId: [''],
      name: [''],
      pct: [{ value: '', disabled: !this.allowEdit }, Validators.compose([Validators.required])],
      numberOfCredits: [{ value: 0, disabled: !this.allowEdit }, Validators.compose([Validators.required, Validators.min(1)])],
      tradingGroup: [{ value: '', disabled: !this.allowEdit }],
      hbt: [{ value: '', disabled: !this.allowEdit }],
      vegClass: [''],
      vegFormation: [''],
      vegetationFormationId: [0],
      vegetationClassId: [0],
      tradingGroupId: [0],
      pctCleared: [''],
      speciesType: [],
      threatStatus: [''],
      cwOffset: [false],
      ibraSubregionText:['']

    });

  }

  loadIbraRegions() {
    this.lookupService.getIbraRegions().subscribe(result => {
      if (result == null) return;
      this.ibraRegions = result.filter(r => r.name !='Anywhere in NSW');
      this.ibraRegions.map((item: any) => {
        var subregions = item.subregions;
        if (subregions != undefined) {
          subregions.map((sr: any) => {
            if (sr.name != undefined && sr.name.toLowerCase() !== 'anywhere in nsw') {
              this.ibraSubRegions.push(sr);
              this.filteredSubregions.push(sr);
            }
          });
        }
      });

    });
  }

  getSubregions(event) {
    const region = Number(event.target.value);
    if (isNaN(region) || region == 0) this.filteredSubregions = this.ibraSubRegions;
    else {
      const selectedRegion = this.ibraRegions.find(s => s.id == region);
      this.filteredSubregions = selectedRegion != null
        ? (selectedRegion.subRegions || selectedRegion.subregions || [])
        : [];
    }
  }

  subregionChanged(event) {
    const subregionId = Number(event.target.value);
    let regionId = "";
    if (!isNaN(subregionId) && subregionId > 0) {
      var subregion = this.ibraSubRegions.find(sr => sr.id == subregionId);
      if (subregion != null) regionId = subregion.ibraRegionId;
    }
    this.fgCredits.patchValue({ ibraRegion: regionId })
  }

  findPct() {
    this.error = "";
    var pct = Number(this.fgCredits.value.pct);
    var ibra = this.ibraRegions.find(r => r.id == Number(this.fgCredits.value.ibraRegion)).name;
    var subregion = this.filteredSubregions.find(r => r.id == Number(this.fgCredits.value.ibraSubregion)).name;
    var category = this.fgCredits.value.creditCategory;
    var url = category.startsWith("E") ? "/api/pct/search/" + pct + "/" + ibra : "/api/credits/species/" + pct + "/" + subregion;
    this.apiService.find(url).subscribe((response: any) => {
      this.pct = response;
      if (this.pct != null) {
        this.fgCredits.patchValue({
          creditTypeId: pct,
          name: response.name
        });
        if (category.startsWith("E")) {
          this.fgCredits.patchValue({
            pctCleared: this.pct.percentCleared,
            vegetationFormationId: this.pct.formationId,
            vegetationClassId: this.pct.vegetationClassId,
            vegClass: this.pct.vegetationClass
          });
        }
        else {
          this.fgCredits.patchValue({
            speciesType: this.pct.speciesType,
            threatStatus: this.pct.status,
            tradingGroup: this.pct.offsetTradingGroup
          });
          this.pct.id = pct;
        }
        this.pctName = this.pct.name;
        this.offsetTradingGroups = this.pct.offsetTradingGroups;

       

      }

    }, error => {
      console.log(error);
      this.error = error.error;
    });

  }

  setTradingGroups(pct: number) {
    this.offsetTradingGroups = [];
    this.obligationService.getTradingGroups(pct).subscribe(result => {
      // Filter out trading groups that have '%' in the trading group name
      this.offsetTradingGroups = result ? result.filter(group => !group.name.includes('%')) : [];
    });
  }

  get name(): string {
    return this.fgCredits.value.name;
  }

  get vegClass(): string {
    return this.fgCredits.value.vegClass;
  }

  get formation(): string {
    return this.fgCredits.value.vegFormation
  }

  get speciesType(): string {
    return this.fgCredits.value.speciesType;
  }

  get pctCleared(): number {
    return this.fgCredits.value.pctCleared;
  }

  get allowEdit(): boolean {
    return this.mode == "A";
  }

  get isEcocredit(): boolean {
    var category = this.fgCredits.get('creditCategory').value;
    return category != null && category.toLowerCase() == "ecosystem";
  }

  get isSpecies(): boolean {
    var category = this.fgCredits.get('creditCategory').value;
    return category != null && category.toLowerCase() == "species";
  }

  get threatStatus(): string {
    return this.fgCredits.get('threatStatus').value;
  }

  get speciesOTG(): string {
    return this.fgCredits.get('tradingGroup').value;
  }

  get tradingGroup(): string {
    return this.fgCredits.get('tradingGroup').value;
  }

  get allowSearch(): boolean {
    return this.mode == "A";
  }

  get isValidOTG(): boolean {
    if (this.isSpecies) return true;
    const val = this.tradingGroup;
    return this.fgCredits.valid && (val == "" || val == null) ? false : true;
  }

  get isValidHBT(): boolean {
    if (this.isSpecies) return true;
    const val = this.fgCredits.get('hbt').value;
    return this.fgCredits.valid && (val == "" || val == null) ? false : true;
  }

  set threatStatus(tecId) {
    var ts = "";
    const id = Number(tecId);
    if (id == 0) {
      // Non TEC - get status by % cleared
      const pctCleared = this.pctCleared;
      if (pctCleared == null || pctCleared == undefined) ts = "";
      if (pctCleared >= 90) ts = "Critically Endangered Ecological Community"
      else if (pctCleared >= 70) ts = "Endangered Ecological Community"
      else ts = "Vulnerable Ecological Community"
    }
    else {
      // get status from OTG for TEC
      var otg = this.offsetTradingGroups.filter(t => t.id == id)[0];
      ts = otg != null ? otg.status : "";
    }

    this.fgCredits.patchValue({ threatStatus: ts });
  }

  open() {
    this.error = "";
    this.mode = "A";
    this.buttonTitle = "Create";
    this.headerTitle = "Add obligation";
    this.ecoOTG = "";
    this.resetForm();
    this.pct = null;
    this.modalReference = this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl', backdrop: 'static' });
    this.fgCredits.get('ibraRegion').disable({ onlySelf: true });
    this.fgCredits.get('ibraSubregion').enable({ onlySelf: true });
    this.fgCredits.get('creditCategory').enable({ onlySelf: true });
    this.fgCredits.get('pct').enable({ onlySelf: true });
    this.fgCredits.get('hbt').enable({ onlySelf: true });
     this.fgCredits.get("hbt").clearValidators();
     this.selectedIbraRegionName = '';
  }

  edit(id, credit) {
    this.credit = credit;
    this.credit.id = id;
    this.error = "";
    this.mode = "E";
    this.resetForm();
    this.buttonTitle = "Update";
    this.headerTitle = "Edit obligation";
    this.obligationId = id;
    var ibra = this.ibraRegions.find(i => i.id == credit.ibraId);
    //if (credit.creditCategory.toLowerCase()=="ecosystem") this.setTradingGroups(credit.creditTypeId, ibra.name);
    this.pct = credit;
    this.pctName = credit.name;
    const selectedRegion = this.ibraRegions.find(s => s.id == credit.ibraId);
    this.filteredSubregions = selectedRegion != null
      ? (selectedRegion.subRegions || selectedRegion.subregions || [])
      : [];
    this.selectedIbraRegionName = this.ibraRegions.filter(s => s.id == credit.ibraId)[0].name;
    this.ecoOTG = credit.offsetTradingGroup;
    this.fgCredits.patchValue({
      id: id,
      creditTypeId: credit.creditTypeId,
      name: credit.name,
      ibraRegion: credit.ibraId,
      ibraSubregion: credit.ibraSubId,
      creditCategory: credit.creditCategory,
      pct: credit.creditTypeId,
      numberOfCredits: credit.totalCredits,
      tradingGroup: credit.offsetTradingGroup,
      tradingGroupId: credit.tradingGroupId,
      hbt: credit.hbt ? "1" : "0",
      vegClass: credit.vegetationClass,
      vegFormation: credit.formation,
      speciesType: credit.speciesType,
      pctCleared: credit.pctCleared,
      threatStatus: credit.threatStatus,
      vegetationFormationId: credit.vegetationFormationId,
      vegetationClassId: credit.vegetationClassId,
      cwOffset: credit.commonwealthOffset,
      ibraSubregionText:credit.ibraSubregion

    });
    this.selectedIbraRegionName = credit.ibraRegion;
    this.fgCredits.get('ibraSubregionText').disable({ onlySelf: true });
    this.fgCredits.get('ibraRegion').disable({ onlySelf: true });
    this.fgCredits.get('ibraSubregion').disable({ onlySelf: true });
    this.fgCredits.get('creditCategory').disable({ onlySelf: true });
    this.fgCredits.get('pct').disable({ onlySelf: true });
    this.fgCredits.get('hbt').disable({ onlySelf: true });

    this.modalReference = this.modalService.open(this.modalContent, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
  }

  resetForm() {
    this.fgCredits.reset();
    this.offsetTradingGroups = null
    this.filteredSubregions = this.ibraSubRegions;
     this.selectedIbraRegionName = '';

  }

  create() {
    if (!this.isValidHBT || !this.isValidOTG) {
      this.helperService.toasterService.error("Please check form validation errors.");
      return;
    }

    if (this.mode == "A") {
      var credit: Credit = this.fgCredits.value;
      const creditCategory = credit.creditCategory;
      const formValues = this.fgCredits.getRawValue();
      
      const ibraSubId = this.selectedSubregionId ;//Number(formValues.ibraSubregion);
      const ibraId = this.selectedRegionId ;//Number(formValues.ibraRegion);
  
      let tradingGroupId = 0;
      let tradingGroup = "";
      console.log('selectedSubregionId', this.selectedSubregionId);
      console.log('filteredSubregions', this.filteredSubregions);
      const subregions = this.filteredSubregions || this.ibraSubRegions || [];
      var subRegion = subregions.find(sr => sr.id == ibraSubId);
      credit.ibraSubId = ibraSubId;
      credit.ibraId = ibraId;
      credit.ibraSubregion = subRegion != null ? subRegion.name : "";
      if (creditCategory.toLowerCase() == "ecosystem") {
        credit.hbt = this.fgCredits.value.hbt == "1";
        tradingGroupId = Number(this.fgCredits.value.tradingGroup);
        credit.tradingGroupId = tradingGroupId;
        if (tradingGroupId == 0) tradingGroup = this.helperService.BuildOTG(this.pctCleared, this.vegClass)
        else {
          const tg = this.offsetTradingGroups.find(t => t.id == tradingGroupId);
          if (tg != null) tradingGroup = tg.name;
        }
      }
      else {
        credit.hbt = null;
        tradingGroup = this.fgCredits.value.tradingGroup;
      }

      credit.offsetTradingGroup = tradingGroup;
      credit.commonwealthOffset = this.fgCredits.value.cwOffset;
      if (credit.commonwealthOffset == null) credit.commonwealthOffset = false;
      this.added.emit(credit);

    }
    else {
      var credit = this.credit;
      credit.numberOfCredits = Number(this.fgCredits.value.numberOfCredits);
      credit.commonwealthOffset = this.fgCredits.value.cwOffset;
      if (credit.commonwealthOffset == null) credit.commonwealthOffset = false;
      this.updated.emit(credit);
    }

    this.modalReference.close();
  }

  getPct(): any {
    var pct = {
      id: this.pct.id,
      creditCategory: this.fgCredits.value.creditCategory,
      name: this.pct.name,
      pctCleared: this.pct.percentCleared,
      formation: this.pct.formation,
      vegetationClass: this.pct.vegetationClass,
      ibraRegion: this.fgCredits.value.ibraRegion,
      ibraSubregion: this.fgCredits.value.ibraSubregion,
      hbt: this.fgCredits.value.hbt,
      credits: this.fgCredits.value.numberOfCredits,
      offsetTradingGroup: this.fgCredits.value.tradingGroup != "" ? this.fgCredits.value.tradingGroup : this.pct.vegetationClass,
      speciesType: this.fgCredits.value.speciesType,
      threatStatus: this.fgCredits.value.threatStatus
    }

    return pct;
  }

  creditCategoryChanged($event) {
    //this.SetValidators($event.target.value);
  }

  SetValidators(creditType) {
    this.error = ""; //reset error
    if (creditType.toLowerCase() == "species") {
      this.fgCredits.get("hbt").clearValidators();
    }
    else if (creditType.toLowerCase() == "ecosystem") {
      this.fgCredits.get("hbt").setValidators(Validators.required);
    }

  }


  credits() {

  }

  tecChanged($event: any) {
    const value = $event.target.value;
    if (value == "") {
      this.ecoOTG = "";
      return;
    }
    this.threatStatus = value;
    const tecId = Number(value);
    if (tecId > 0) {
      const tg = this.offsetTradingGroups.find(t => t.id == tecId);
      if (tg != null) this.ecoOTG = tg.name;
    }
    else this.ecoOTG = this.helperService.BuildOTG(this.fgCredits.get('pctCleared').value, this.fgCredits.get('vegClass').value);

  }

  creditSelected($event: any) {
    const id = Number($event.id);
    const credit = $event;
    if (isNaN(id)) return;
    //var ibra = this.ibraRegions.find(i => i.id.toString() == this.fgCredits.value.ibraRegion);
    var ibra = this.ibraRegions.find(i => i.id.toString() == this.selectedRegionId);
    this.fgCredits.patchValue({
      pct: id,
      creditTypeId: id,
      name: credit.name,
      vegClass: credit.vegetationClass,
      vegFormation: credit.formation,
      vegetationFormationId: credit.formationId,
      vegetationClassId: credit.vegetationClassId,
      speciesType: credit.speciesType,
      pctCleared: this.isEcocredit ? credit.percentCleared : "",
      threatStatus: credit.status,
      tec: "",
      //tradingGroup: this.isEcocredit ? this.helperService.BuildOTG(id, credit.vegetationClass) : this.helperService.BuildSpeciesOTG(credit.name, credit.scientificName)
      tradingGroup: this.isEcocredit ? "" : this.helperService.BuildSpeciesOTG(credit.name, credit.scientificName)
    });

    //set offset trading groups
    if (this.isEcocredit) {
      this.offsetTradingGroups = [];
      this.setTradingGroups(id);
    }
    
  }

  onChangeSearch($event: any) {

    const keyword = $event;
    const category = this.fgCredits.value.creditCategory;
    let minLength: Number = 3;
    if (!isNaN(keyword)) minLength = 2;
    if (keyword != null && keyword.length >= minLength) {
      this.obligationService.searchCredit(category, keyword, "").subscribe(results => {
        //console.log(results,"Quick search results...");
        this.creditSearchResults = results.map(result => ({
          ...result,
          combined: `${result.name} ${result.id}`
        }));
      }, error => {
        console.log(error, "error in credit keyword search");
      }

      );
    }

  }

  formatCreditResult(item: any): string {
    if (item == null || item == undefined) return "";
    return `${item.id} - ${item.name}`
  }

  categoryChanged($event: any) {
    this.creditSearchResults = [];
    this.offsetTradingGroups = null
    this.fgCredits.patchValue({
      creditTypeId: null,
      name: null,
      pct: null,
      numberOfCredits: 0,
      tradingGroup: null,
      tradingGroupId: null,
      hbt: "",
      vegClass: null,
      vegFormation: null,
      speciesType: null,
      pctCleared: 0,
      threatStatus: null,
      vegetationFormationId: null,
      vegetationClassId: null,
      cwOffset: null
    });
    this.SetValidators($event.target.value);
    this.clearCreditAutocomplete();
  }

  private clearCreditAutocomplete(): void {
  this.showCreditSearch = false;

  setTimeout(() => {
    this.showCreditSearch = true;
  });
}

  formatResult(item: any): string {
     if (item == null || item == undefined) return "IBRA subregion not found";
    return item.name;
  }

   onChangeIBRASearch($event: any): void {
    const keyword = $event;
    this.ibraKeyword = keyword;
    if (keyword == null || keyword == undefined) return null;

    const selectedSubregion = this.ibraSubRegions.find((s: any) => s.id == this.selectedSubregionId);
    const selectedSubregionName = selectedSubregion != null ? selectedSubregion.name.toLowerCase() : "";
    const typedValue = keyword.trim().toLowerCase();
    const isExistingSelection = this.selectedSubregionId > 0 && selectedSubregionName == typedValue;

    if (!isExistingSelection) {
      this.clearSelectedIbraValues();
      this.isIbraSubregionSelectionInvalid = typedValue.length > 0;
      const ibraSubregionControl = this.fgCredits.get('ibraSubregion');
      if (ibraSubregionControl != null) {
        ibraSubregionControl.markAsTouched();
        if (typedValue.length > 0) {
          ibraSubregionControl.setErrors({ ...(ibraSubregionControl.errors || {}), invalidSelection: true });
        }
      }
    }

    if (keyword.length >= 2) {
      this.autoCompleteSubregions = this.ibraSubRegions.filter(s =>
        s.name.toLowerCase().includes(keyword.trim().toLowerCase()));

    };
  
    
  }

  ibraSelected($event: any): void {
    const keyword = $event;
    var ibra = this.ibraRegions.find(r => r.id == Number(keyword.ibraRegionId));

    if (ibra != null) {
      this.selectedRegionId = keyword.ibraRegionId;
      this.selectedSubregionId = keyword.id;
      this.selectedIbraRegionName = ibra.name;
      this.isIbraSubregionSelectionInvalid = false;

      this.fgCredits.patchValue({
        ibraRegion: ibra.id,
        ibraSubregion: keyword.id
      });

      const ibraSubregionControl = this.fgCredits.get('ibraSubregion');
      if (ibraSubregionControl != null) {
        const errors = { ...(ibraSubregionControl.errors || {}) };
        delete errors.invalidSelection;
        ibraSubregionControl.setErrors(Object.keys(errors).length > 0 ? errors : null);
      }

      this.filteredSubregions = ibra.subRegions || ibra.subregions || [];
    }

  }

  private clearSelectedIbraValues(): void {
    this.selectedRegionId = 0;
    this.selectedSubregionId = 0;
    this.selectedIbraRegionName = '';
    this.fgCredits.patchValue({
      ibraRegion: '',
      ibraSubregion: ''
    });
  }
}
